import React, { Component } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import _ from 'lodash';
import logo from '../assets/images/sla-logo-dark.png';
import { changeTheme, logoutUser } from '../api/authenticationApi';
import {
  settingAr,
  settingDark,
  settingDarkTable,
  settingDropdown,
  settingEn,
} from '../helpers/translations/cssClassHelper';
import { setNavigationLang } from '../helpers/translations/config';
import Logo from './Logo';
import LogoWhite from './LogoWhite';
import { MoonIcon } from './ui/MoonIcon';
import { SunIcon } from './ui/SunIcon';
import { clearLS, getLS, removeLS, setLS } from '../helpers/utils';

export class Navigation extends Component {
  constructor(props) {
    super(props);
    const { locale } = props;
    this.defaultLang = locale || null;

    this.state = {
      // eslint-disable-next-line react/no-unused-state
      menu: false,
      locale: null,
      defaultLang: null,
      // eslint-disable-next-line react/no-unused-state
      isRTL: false,
      // eslint-disable-next-line react/no-unused-state
      dark: false,
    };
  }

  // eslint-disable-next-line react/sort-comp
  changeTheme = (mode) => {
    const { changeTheme } = this.props;
    // eslint-disable-next-line react/no-unused-state
    this.setState({ dark: mode });
    setLS('dark', mode);
    settingDark(mode);
    settingDropdown(mode);
    settingDarkTable(mode);
    this.hideNavBar();
    changeTheme(mode);
  };

  // eslint-disable-next-line class-methods-use-this
  toggleNavbar = (e) => {
    e.preventDefault();
    const nav = document.getElementsByClassName('navbar-collapse')[0];
    nav.classList.add('bg-light', 'shadow', 'pt-2');
  };

  // eslint-disable-next-line class-methods-use-this
  hideNavBar = () => {
    const nav = document.getElementById('navbarSupportedContent');
    if (nav) nav.classList.remove('show');
  };

  useDefaultLanguage = (e, i18n) => {
    e.preventDefault();
    i18n.changeLanguage('en');
    // eslint-disable-next-line react/no-unused-state
    this.setState({ isRTL: false });
    settingEn(i18n);
    this.hideNavBar();
    this.toggleNavbar(e);
  };

  changeLanguage = (e, i18n, lang, locale) => {
    e.preventDefault();
    this.toggleNavbar(e);

    setLS('isActive', lang === 'en' ? 'true' : 'false');

    const { unsub } = this.props;
    if (unsub) {
      if (locale && locale !== 'en') i18n.changeLanguage(locale);
      else i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage(lang);
    }

    if ((unsub && locale === 'ar') || (!unsub && lang === 'ar')) {
      // eslint-disable-next-line react/no-unused-state
      this.setState({ isRTL: true });
      settingAr(i18n);
    } else {
      // eslint-disable-next-line react/no-unused-state
      this.setState({ isRTL: false });
      settingEn(i18n);
    }
    this.hideNavBar();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { i18n, history, logoutUser } = this.props;
    settingEn(i18n);
    settingDark(getLS('dark'));
    logoutUser(history);
  };

  checkOtherLang = (i18n, locale) => {
    const { unsub } = this.props;
    const { defaultLang } = this.state;

    let lang = null;
    if (!unsub) {
      lang = setNavigationLang(defaultLang);
    } else if (locale !== 'en') {
      lang = setNavigationLang(locale || this.defaultLang);
    }

    return (
        <>
          <li className="nav-item">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
                href="#"
                className={
                  // eslint-disable-next-line no-nested-ternary
                  _.isEmpty(getLS('isActive'))
                      ? 'nav-link active ml-2 '
                      : getLS('isActive') === 'false'
                          ? 'nav-link active ml-2 '
                          : 'nav-link ml-2 '
                }
                onClick={(e) => this.changeLanguage(e, i18n, defaultLang, locale)}
            >
              <i className="fa fa-language" />
              {lang}
              <span className="sr-only">(current)</span>
            </a>
          </li>
        </>
    );
  };

  // ✅ Kept as requested, but with destructuring to satisfy ESLint
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { unsub, locale } = nextProps;
    const { locale: stateLocale } = this.state;

    if (unsub && locale !== stateLocale) {
      i18next.changeLanguage(locale);
      this.setState({ locale });
    }
  }

  componentDidMount() {
    const defaultLang = getLS('defaultLang');
    this.setState({ defaultLang });

    const { unsub, i18n, locale } = this.props;
    if (unsub) {
      i18n.changeLanguage(locale || defaultLang);
    }
  }

  renderNavLang(i18n) {
    const { i18n: i18nProp, locale } = this.props;
    return (
        <>
          <ul className={i18nProp.language === 'ar' ? 'navbar-nav nav-ar' : 'navbar-nav ml-auto'}>
            <li className="nav-item">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                  href="#"
                  className={getLS('isActive') === 'true' ? 'nav-link active ml-2 ' : 'nav-link ml-2'}
                  onClick={(e) => this.useDefaultLanguage(e, i18n)}
              >
                <i className="fa fa-language" />
                English
              </a>
            </li>
            {this.checkOtherLang(i18n, locale)}
          </ul>
        </>
    );
  }

  render() {
    const { i18n, t, location, unsub, locale } = this.props;

    settingDark(getLS('dark'));
    const isDark = getLS('dark') === 'true';
    const notEn = (!unsub && getLS('defaultLang') !== 'en') || (unsub && locale !== 'en');

    return (
        <div data-test="component-navigation">
          <nav className={isDark ? 'navbar navbar-expand-lg navbar-dark' : 'navbar navbar-expand-lg navbar-light'}>
            <Link className="navbar-brand" to={location}>
              {isDark ? <LogoWhite /> : <Logo />}
            </Link>

            <button
                onClick={this.toggleNavbar}
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              {!unsub ? (
                  <ul className={i18n.language === 'ar' ? 'navbar-nav ml-auto  nav-ar' : 'navbar-nav mr-auto'}>
                    <li className="nav-item">
                      <NavLink
                          className={isDark ? 'nav-link nav-link-theme-dark ml-2' : 'nav-link ml-2'}
                          to="/transactions"
                          activeClassName="active"
                      >
                        <i className="fa fa-history" />
                        {t('transaction-history')}
                        <span className="sr-only">(current)</span>
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                          className={isDark ? 'nav-link nav-link-theme-dark ml-2' : 'nav-link ml-2'}
                          to="/subscriptions"
                          activeClassName="active"
                      >
                        <i className="fa fa-cloud" />
                        {t('subscription')}
                        <span className="sr-only">(current)</span>
                      </NavLink>
                    </li>
                  </ul>
              ) : (
                  <ul className={i18n.language === 'ar' ? 'navbar-nav ml-auto nav-ar' : 'navbar-nav mr-auto'} />
              )}

              {notEn ? this.renderNavLang(i18n) : null}

              {isDark ? (
                  <div className="nav-link-theme-dark">
                    {/* eslint-disable-next-line react/button-has-type */}
                    <button className="btn my-sm-0" onClick={() => this.changeTheme('false')}>
                      <SunIcon />
                      <span className="btn-dark-visible pl-2">{t('Light')}</span>
                    </button>
                  </div>
              ) : null}

              {!isDark ? (
                  <div className="nav-link-theme">
                    {/* eslint-disable-next-line react/button-has-type */}
                    <button className="btn my-sm-0" onClick={() => this.changeTheme('true')}>
                      <MoonIcon />
                      <span className="btn-white-visible pl-2">{t('Dark')}</span>
                    </button>
                  </div>
              ) : null}

              {!unsub ? (
                  <form
                      data-test="component-logout-form-control"
                      className={
                        isDark
                            ? 'nav-link ml-2 form-inline my-2 my-lg-0 nav-link-theme-dark'
                            : 'nav-link ml-2 form-inline my-2 my-lg-0'
                      }
                      onSubmit={this.handleSubmit}
                  >
                    <button className="btn btn-outline-success my-2 my-sm-0 ml-2 mb-0 mt-0" type="submit">
                      {t('log-out')}
                    </button>
                  </form>
              ) : null}
            </div>
          </nav>
        </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  logoutUser: (history) => dispatch(logoutUser(history)),
  changeTheme: (data) => dispatch(changeTheme(data)),
});

export default withTranslation('lang')(withRouter(connect(null, mapDispatchToProps)(Navigation)));
